
import { Component, Watch, Prop, Vue } from "vue-property-decorator";

@Component
export default class InputWithText extends Vue {
  @Prop({
    type: String,
    required: true
  })
  value!: string; //值
  @Prop({
    type: Array,
    default: []
  })
  options!: any[]; //选项

  valueMine = ""; //维护一份自己的吧

  showTextUp = false; //clss控制
  showTextDown = true;

  //动画class & 吐值
  @Watch("valueMine")
  tt(n: any, o: any) {
    if (o === "" && n !== "") {
      this.TU();
    }
    if (o !== "" && n === "") {
      this.TD();
    }
    this.$emit("input", n);
  }
  mounted() {
    this.valueMine = this.value;
  }
  //飞上去
  TU() {
    this.showTextDown = false;
    this.showTextUp = true;
  }
  //飞下来
  TD() {
    this.showTextDown = true;
    this.showTextUp = false;
  }
}
